<template>
  <div
    class="ProductPrice relative type-sm "
    :class="{
      'mb-0': design === 'plpGrid',
      'mb-24 gap-0 desk:gap-2 ': design !== 'plpGrid' && design !== 'list' && design !== 'plpCompact'
    }"
  >
    <div v-if="userPrice.status === 'ok' && design === 'standard'">
      <p
        v-for="(flag, index) in displayFlags"
        :key="'flag-' + flag.text"
        class="inline-block type-headline-sm text-text-brandStrong uppercase mb-6"
      >
        {{ flag.text }}
        <span v-if="index + 1 !== displayFlags.length">
          -
        </span>
      </p>
    </div>
    <div
      v-if="userPrice.status === 'logginIn' || userPrice.status === 'pending'"
      class="priceLoadBox"
    />
    <div v-if="shouldUseArea && userPrice.status === 'ok'" class="mb-4">
      <div v-if="design === 'list'" class="type-headline-sm">{{ productPrice(userPrice.price, 'price', true) }}</div>
      <component
        :is="design === 'standard' ? 'h2':'div'"
        v-if="uiStore.overrideDisplayPrice > -1 && design === 'standard'"
        class="whitespace-nowrap type-headline-lg inline-block mr-12 text-text-errorStrong"
      >
        {{ useLocalizedCurrency(overrideAreaPrice) }}/{{ unitDisplay }}
      </component>
      <component
        :is="design === 'standard' ? 'h2':'div'"
        v-if="convertPackageToAreaprice.status === 'ok' && areaPrice"
        class="whitespace-nowrap text-darkest inline-block"
        :class="{
          '!text-text-errorStrong': userPrice.price?.isCampaignPrice,
          'type-headline-lg': design === 'standard',
          'type-text-xs': design === 'list' || design === 'plpCompact',
          'type-label-sm mb-0': design === 'plpGrid',
          '!text-text-subtle line-through': uiStore.overrideDisplayPrice > -1 && design === 'standard'
        }"
      >
        {{ useLocalizedCurrency(areaPrice) }}/{{ unitDisplay }}
      </component>
      <!-- if user has discount -->
      <div
        v-if="userPrice.price?.isCampaignPrice && convertPackageToAreaprice.status === 'ok' && areaPriceBeforeDiscount && areaPrice !== areaPriceBeforeDiscount"
        class="whitespace-nowrap text-text-subtle inline-block type-text-sm  line-through"
        :class="{
          'ml-6': design !== 'plpCompact'
        }"
      >
        {{ useLocalizedCurrency(areaPriceBeforeDiscount) }}/{{ unitDisplay }}
      </div>
      <!-- check if we override price, the reason we override price is that quantity breaks is reached -->
      <p v-if="uiStore.overrideDisplayPrice > -1 && design === 'standard'" class="pt-4">
        <span>{{
          $t('areaConvert.pricePerPack', { price: useLocalizedCurrency(uiStore.overrideDisplayPrice) })
        }}</span>

        <span
          v-if="(userPrice.price?.isCustomerPrice && userPrice.price?.discountPercentage > 0) || userPrice.price?.isCampaignPrice || isUserDiscounted"
          class="text-dark line-through inline-block ml-8"
          :class="{'leading-single': design === 'list' || design === 'plpGrid'}"
        >
          {{ productPrice(userPrice.price, 'priceBeforeDiscount', true) }}
        </span>
      </p>
      <p v-else-if="design === 'standard'" class="pt-4">
        <span>{{ $t('areaConvert.pricePerPack', { price: productPrice(userPrice.price, 'price', true) }) }}</span>
        <span
          v-if="(userPrice.price?.isCustomerPrice && userPrice.price?.discountPercentage > 0) || userPrice.price?.isCampaignPrice || isUserDiscounted"
          class="text-dark line-through inline-block ml-8"
        >
          &nbsp;{{ productPrice(userPrice.price, 'priceBeforeDiscount', true) }}
        </span>
      </p>
    </div>
    <h2
      v-else-if="userPrice.status === 'ok'"
      class="whitespace-nowrap text-darkest type-headline-lg"
      :class="{
        'text-criticalDark': isUserDiscounted,
        'type-headline-xl': design !== 'standard',
        'type-sm-medium': design === 'plpGrid' ,
        'type-headline-sm': design === 'list' || design !== 'plpCompact',
        '!type-sm': design === 'list' || design === 'plpCompact',
      }"
    >
      {{ productPrice(userPrice.price, 'price', true) }}
    </h2>
    <!-- DONT SHOW FOR NOW -->
    <!--    <p-->
    <!--      v-if="!shouldUseArea && ((userPrice.price?.isCustomerPrice && userPrice.price?.discountPercentage > 0) || userPrice.price?.isCampaignPrice || isUserDiscounted)"-->
    <!--      class="text-dark"-->
    <!--      :class="{'leading-single': design === 'list' || design === 'plpGrid'}"-->
    <!--    >-->
    <!--      {{ $t('productPage.price.original') }} {{ productPrice(userPrice.price, 'priceBeforeDiscount', true) }}-->
    <!--      <span v-if="userPrice.price?.isCustomerPrice" :class="{'hidden': design === 'list' || design === 'plpGrid'}">-->
    <!--        ({{ $t('productPage.price.yourDiscount') }} <span class="text-criticalDark">{{ userPrice.price?.discountPercentage }}%</span>)-->
    <!--      </span>-->
    <!--    </p>-->

    <!-- "Your discount: X%" -->
    <!--    <p
      v-if="recommendedPrice && design !== 'list' && userPrice.price?.isCampaignPrice && userPrice.price?.discountPercentage && userPrice.price.discountPercentage > 0"
      class="type-sm text-text-inactive desk:type-sm text-dark mb-8 mt-4"
      :class="{
        'leading-single': design === 'plpGrid',
      }"
    >
      {{ $t('priceInfo.yourDiscount.percent' ) }}<span class="type-headline-sm text-text-errorStrong"> {{ userPrice.price.discountPercentage }}%</span>
    </p>-->

    <!-- recommended price -->
    <p
      v-if="recommendedPrice && design !== 'list' && design !== 'plpCompact'"
      class="type-xs desk:type-sm text-dark"
      :class="{
        'leading-single': design === 'plpGrid',
      }"
    >
      <span>{{ $t('product.recommendedPrice.short') }} {{ recommendedPrice }}</span>
    </p>
    <p
      v-if="design === 'standard' && userPrice.status === 'ok'"
      class="mt-8 type-sm text-text-subtle"
    >
      {{ globalContent.getDisplayIncVat ? $t('price.incVat.short'):$t('price.exVat.short') }}
    </p>

    <!--    <p
      v-if="design === 'plpGrid' && globalContent.getIsB2c"
      class="mt-0 type-sm text-text-subtle"
    >
      {{ globalContent.getDisplayIncVat ? $t('price.incVat.rec'):$t('price.exVat.rec') }}
    </p>-->
  </div>
</template>

<script setup lang="ts">
import { ProductModel } from '~/models/product';
import { ProductVariantModel } from '~/models/productVariant';
import { useUserStore } from '~/store/user';
import usePrices from '~/composeables/usePrices';
import usePackageAreaConverter from '~/composeables/usePackageAreaConverter';
import { useLocalizedCurrency } from '~/composeables/useLocalizedCurrency';
import { useGlobalContentStore } from '~/store/globalContent';
import { useUiStore } from '~/store/ui';
import useWarehouse from '~/composeables/useWarehouse';

const globalContent = useGlobalContentStore();
const uiStore = useUiStore();
const { getVariantStockValue } = useWarehouse();

/**
 * plpCompact is almost the same as list, except it doesn't show package price
 */
const props = defineProps<{
  productItem: ProductModel,
  activeVariant: ProductVariantModel,
  crossell?: boolean,
  design: 'standard' | 'list' | 'plpGrid' | 'plpCompact'
}>();

const userStore = useUserStore();

const { productPrice } = usePrices();

const { convertPackageToAreaprice, unitDisplay, shouldUseArea ,convertPackagePriceToAreaPrice } = usePackageAreaConverter(toRef(()=>props.activeVariant));

const userPrice = computed(()=> {
  return userStore.getPrice(props.activeVariant.partNo, props.crossell ?? false);
});

const isUserDiscounted = computed(()=> {
  return userStore.isSalePrice(props.activeVariant.partNo);
});

const displayFlags = computed(()=> {
  const stockValue = getVariantStockValue(props.activeVariant);
  const isInStock = stockValue > 0;
  if (isInStock) {
    return props.productItem.displayFlags.filter((f)=> f.code !== 'onDemand');
  }
  return props.productItem.displayFlags;
});

const areaPrice = computed(()=> {
  if (shouldUseArea.value && userPrice.value.status === 'ok') {
    return globalContent.getDisplayIncVat ? convertPackageToAreaprice.value.price?.price : convertPackageToAreaprice.value.price?.priceBeforeVat;
  }
  return null;
});

const areaPriceBeforeDiscount = computed(()=> {
  if (shouldUseArea.value && userPrice.value.status === 'ok') {
    return globalContent.getDisplayIncVat ? convertPackageToAreaprice.value.price?.priceBeforeDiscount : convertPackageToAreaprice.value.price?.priceBeforeDiscountBeforeVat;
  }
  return null;
});

const overrideAreaPrice = computed(()=> {
  if (shouldUseArea.value && uiStore.overrideDisplayPrice > -1 && props.design === 'standard') {
    return convertPackagePriceToAreaPrice(uiStore.overrideDisplayPrice);
  }
  return null;
});

/**
 * @todo - this doesn't work since recommendedPrice is wrong and recommendedPriceBeforeVat is missing
 */
const recommendedPrice = computed(()=> {
  if (!userPrice.value.price?.recommendedPrice) {
    return null;
  }

  /*  if (userPrice.value.price?.priceBeforeDiscountBeforeVat === userPrice.value.price?.recommendedPrice && !userPrice.value.price?.isCampaignPrice) {
    return null;
  }*/

  let convertPrice = parseFloat(userPrice.value?.price?.recommendedPrice) || -1;

  if (shouldUseArea.value) {

    /*if (globalContent.getDisplayIncVat) {
      convertPrice = parseFloat(userPrice.value?.price?.recommendedPrice) || -1;
    } else {
      convertPrice = parseFloat(userPrice.value?.price?.recommendedPriceBeforeVat) || -1;
    }*/
    if (convertPrice === -1) {
      return null;
    }

    return useLocalizedCurrency(convertPackagePriceToAreaPrice(convertPrice)) + '/' + unitDisplay;
  }
  //return globalContent.getDisplayIncVat ? userPrice.value?.price?.recommendedPriceDisplay : userPrice.value?.price?.recommendedPriceBeforeVatDisplay;
  return useLocalizedCurrency(convertPrice);
});

</script>

<style scoped lang="postcss">

.priceLoadBox {
  @apply block mt-4 w-64 min-h-24;
  color: rgba(0,0,0,0);
  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-direction: alternate;
}

@keyframes spin {
  from {
    background-color: #DEDDD9;
  }
  to {
    background-color: #F5F4F0;
  }
}

</style>
